export const normalizeReport = (...args) => {
  return import(
  // @ts-expect-error migrate upstream
  /* webpackChunkName: "report-migration" */
  'reporting-reports/normalizeReport').then(module => {
    const func = module.default;
    return func(...args);
  });
};